export const validateDate = (value: any) => {
  if (!value) return null;
  const date = new Date(value);
  return isNaN(date as unknown as number) ? null : date;
};
